module.exports = __webpack_public_path__ + "assets/images/businessCard-02.d0d3f52197ba3934768635c4b62eb8c7.svg";